import { HamburgerButton } from '@/components/navigation/hamburger-button';
import { Text } from '@/components/ui/text';
import { useResponsiveShellOptional } from '@/providers/responsive-shell-provider';
import Ionicons from '@expo/vector-icons/Ionicons';
import { useRouter } from 'expo-router';
import React from 'react';
import { Pressable, View } from 'react-native';

interface ScreenHeaderProps {
  title: string;
  subtitle?: string;
  rightSlot?: React.ReactNode;
  showBackButton?: boolean;
  onBackPress?: () => void;
  showMenuButton?: boolean;
}

export function ScreenHeader({
  title,
  subtitle,
  rightSlot,
  showBackButton = false,
  onBackPress,
  showMenuButton = false,
}: ScreenHeaderProps) {
  const router = useRouter();
  const shell = useResponsiveShellOptional();

  const handleBackPress = () => {
    if (onBackPress) {
      onBackPress();
    } else {
      router.back();
    }
  };

  const shouldShowMenuButton = showMenuButton && shell && !shell.isDesktop;

  return (
    <View className="px-4 pt-4 pb-2 flex-row justify-between items-center">
      <View className="flex-1 flex-row items-center">
        {shouldShowMenuButton && (
          <View style={{ marginRight: 12 }}>
            <HamburgerButton onPress={shell!.openDrawer} />
          </View>
        )}
        {showBackButton && (
          <Pressable
            onPress={handleBackPress}
            style={{ marginRight: 12 }}
            hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
            accessibilityRole="button"
            accessibilityLabel="Go back"
          >
            <Ionicons
              name="arrow-back"
              size={24}
              className="text-foreground"
            />
          </Pressable>
        )}
        <View className="flex-1">
          <Text className="text-2xl font-bold text-foreground" accessibilityRole="header">
            {title}
          </Text>
          {subtitle && (
            <Text className="text-sm text-muted-foreground">
              {subtitle}
            </Text>
          )}
        </View>
      </View>
      {rightSlot && (
        <View className="ml-4">
          {rightSlot}
        </View>
      )}
    </View>
  );
}
